import { connect } from 'react-redux';
import moment from 'moment';
import { SERVICE_TYPES } from '@bagonboard/wiseman';

import getAvailableDates from './getAvailableDates';

const {
  CHECKIN,
  SKIP_BAGGAGE_CLAIM,
  TRANSFER,
  CITY_DELIVERY,
} = SERVICE_TYPES;

export const getNeededFields = (serviceType) => {
  switch (serviceType) {
    case CHECKIN:
      return ['pickup'];
    case SKIP_BAGGAGE_CLAIM:
      return ['delivery'];
    default:
      return ['pickup', 'delivery'];
  }
};

export const getOriginOrDestination = serviceType => (serviceType === CITY_DELIVERY ? 'destination' : 'origin');
export const getLimitDate = (serviceType, sourceDate) => {
  const date = moment.utc(sourceDate);
  if (serviceType === CITY_DELIVERY) {
    return date.add(1, 'day').format();
  }
  return date.format();
};

export const mapStateToProps = (state, { flightSelected, serviceType }) => {
  // Retrive info about the logic depending on the service
  const neededFields = getNeededFields(serviceType);
  const dependsOnPickup = [TRANSFER, CITY_DELIVERY].includes(serviceType);
  // Fetch the proper data from the state
  const { products, flight: { flightData } } = state.flightProducts.data[flightSelected];
  const selectedProduct = products.find(
    productItem => productItem.service === serviceType,
  );
  const pickupDates = getAvailableDates(selectedProduct.pickupSlots);
  const deliveryDates = getAvailableDates(selectedProduct.deliverySlots);
  const sourceDate = flightData[getOriginOrDestination(serviceType)].date;
  const limitDate = getLimitDate(serviceType, sourceDate);
  return {
    needsPickup  : neededFields.includes('pickup'),
    needsDelivery: neededFields.includes('delivery'),
    dependsOnPickup,
    pickupDates,
    deliveryDates,
    requestParams: {
      airline : flightData.airline,
      service : serviceType,
      cityCode: flightData[getOriginOrDestination(serviceType)].airportCode,
      limitDate,
    },
  };
};

export default connect(mapStateToProps);
